import React from 'react';
import MetodoPageTemplate from '../../components/template-il-mio-metodo-di-lavoro';
import { getProp, getPropMarked, getPropRel } from '../utils';

const MetodoPagePreview = (props) => {
  const title = getProp(props, 'title');
  const intro = getPropMarked(props, 'intro');
  const titleStrumenti = getProp(props, 'titleStrumenti');
  const strumenti = getPropRel(props, 'strumenti', 'strumento');
  const data = { title, intro, titleStrumenti, strumenti };

  return <MetodoPageTemplate {...data} />;
};

export default MetodoPagePreview;
